






















































import Vue from 'vue';
import moment from 'moment';
import MediaThumbnail from '@/web/components/products/MediaThumbnail.vue';
import MediaViewsModal from '@/web/components/media-library/MediaViewsModal.vue';
import MediaLikesModal from '@/web/components/media-library/MediaLikesModal.vue';
import { formatDate } from '@/web/utils/format';

export default Vue.extend({
  name: 'MediaItemCard',
  components: {
    MediaThumbnail,
  },
  props: {
    media: {
      type: Object as () => MediaDetailResponse,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    animated: {
      type: Boolean,
      default: true,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    isReleasedInFuture() {
      return moment(this.media.release_on).isAfter(moment());
    },
    formattedReleaseDate() {
      return formatDate(this.media.release_on, 'date-time');
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MMM DD, yyyy');
    },
    openViewsModal(media) {
      this.$modal.show(MediaViewsModal, { media });
    },
    openLikesModal(media) {
      this.$modal.show(MediaLikesModal, { media });
    },
  },
});
